import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Menu, X, Package } from "lucide-react";
import { useMe } from "@/lib/api";

export const Logo = ({ light }) => (
  <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
    <span className="h-9 w-9 bg-[#FF6B00] flex items-center justify-center rounded-sm">
      <Package className="h-5 w-5 text-white" strokeWidth={2.5} />
    </span>
    <span className={`font-display font-extrabold tracking-tight text-lg leading-none ${light ? "text-white" : "text-[#0A192F]"}`}>
      INLA<span className="text-[#FF6B00]">.</span>SHIPPING HUB
    </span>
  </Link>
);

function NavLinks({ onClick }) {
  const { data: me } = useMe();
  const cls = ({ isActive }) => `nav-link text-sm font-medium ${isActive ? "active text-[#0A192F]" : "text-slate-600 hover:text-[#0A192F]"}`;
  return (
    <>
      <NavLink to="/track" className={cls} onClick={onClick} data-testid="nav-track">Track</NavLink>
      <NavLink to="/book" className={cls} onClick={onClick} data-testid="nav-book">Book Shipment</NavLink>
      <NavLink to="/contact" className={cls} onClick={onClick} data-testid="nav-contact">Contact</NavLink>
      <Show when="signed-in">
        <NavLink to="/dashboard" className={cls} onClick={onClick} data-testid="nav-dashboard">My Shipments</NavLink>
      </Show>
      <NavLink to={me?.role === "admin" ? "/admin" : "/admin/login"} className={cls} onClick={onClick} data-testid="nav-admin">Admin</NavLink>
    </>
  );
}

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-white/90 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8"><NavLinks /></nav>
        <div className="flex items-center gap-3">
          <Show when="signed-out">
            <Link to="/sign-in" data-testid="header-sign-in-btn" className="hidden sm:inline-flex text-sm font-semibold px-4 py-2 text-[#0A192F] hover:text-[#FF6B00] transition-colors">Sign in</Link>
            <Link to="/sign-up" data-testid="header-sign-up-btn" className="inline-flex text-sm font-semibold px-4 py-2 bg-[#FF6B00] text-white rounded-sm hover:bg-[#E05D00] transition-colors">Sign up</Link>
          </Show>
          <Show when="signed-in"><UserButton /></Show>
          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-slate-200 bg-white px-4 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          <NavLinks onClick={() => setOpen(false)} />
          <Show when="signed-out">
            <Link to="/sign-in" onClick={() => setOpen(false)} data-testid="mobile-sign-in-btn" className="text-sm font-semibold text-[#0A192F]">Sign in</Link>
            <Link to="/sign-up" onClick={() => setOpen(false)} data-testid="mobile-sign-up-btn" className="text-sm font-semibold text-[#FF6B00]">Create an account</Link>
          </Show>
        </nav>
      )}
    </header>
  );
}
